export default __webpack_public_path__ + "static/B0178-545b072d7991ac49adac355b18686204.png";